import { Button } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import { graphql } from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";
import { ModifySubscriptionLinkMutation } from "./__generated__/ModifySubscriptionLinkMutation.graphql";
import { useSnackbar } from "notistack";

const modifySubscriptionLinkMutation = graphql`
  mutation ModifySubscriptionLinkMutation($name: String!) {
    modifySubscriptionLink(organization: $name) {
      url
    }
  }
`;

function ModifySubscription() {
  const [commit, isInFlight] = useMutation<ModifySubscriptionLinkMutation>(
    modifySubscriptionLinkMutation,
  );
  const { organization } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  if (!organization) {
    return null;
  }

  const handleClick = () => {
    commit({
      variables: {
        name: organization,
      },
      onCompleted: (response, errors) => {
        errors?.forEach((error) => {
          enqueueSnackbar(error.message, {
            variant: "error",
          });
        });

        if (response.modifySubscriptionLink?.url) {
          window.location.assign(response.modifySubscriptionLink.url);
        }
      },
      onError: (error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      },
    });
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleClick}
        disabled={isInFlight}
      >
        Modify subscription
      </Button>
    </>
  );
}

export default ModifySubscription;
